<template>
  <div>
    <div  class="table-wrapper">
      <table class="table is-fullwidth is-hoverable">
        <es-sorter
          :columnHeaders="columnHeaders"
          @updateSorter="updateSorter"
        />
        <tbody v-if="loading">
          <td class="td-alert" colspan="100">
            <es-loader style="margin: 4.5rem"/>
          </td>
        </tbody>
        <tbody v-else-if="loadingError">
          <td class="td-alert" colspan="100">
            <es-exception
            exceptionMessage="There was an issue. Please try again or contact your administrator."
            margin="4.rem"
            />
          </td>
        </tbody>
        <tbody v-else-if="!transactions.length">
          <td class="td-alert" colspan="100">
            <es-exception
              exceptionMessage="No results found."
              margin="3rem"
            />
          </td>
        </tbody>
        <template v-else>
          <pid-transaction-row
            v-for="transaction in transactions"
            :key="transaction.id"
            :transObject="transaction"
            :isMobile="isMobile"
          />
        </template>
      </table>
    </div>
    <div class="pager-container" v-if="!loading && totalCount">
      <es-pager :totalCount="totalCount"/>
    </div>
  </div>
</template>

<script>

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEllipsisV,
} from '@fortawesome/pro-light-svg-icons';
import {
  faExclamationTriangle,
} from '@fortawesome/pro-solid-svg-icons';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsPager from '@/components/EsPager.vue';
import PidTransactionRow from '@/components/PidTransactionRow.vue';
import EsSorter from '@/components/EsSorter.vue';
import { isMobile } from '@/mixins/Utils';

library.add(
  faEllipsisV,
  faExclamationTriangle,
);

export default {
  components: {
    EsException,
    EsPager,
    EsLoader,
    EsSorter,
    PidTransactionRow,
  },
  props: {
    transactions: {
      type: Array,
    },
    columnHeaders: {
      type: Array,
      default: () => [
        {
          header: null,
          field: null,
          style: {
            width: '55px',
          },
        },
        {
          header: 'Transaction Info',
          title: 'Transaction Info',
          field: null,
          style: {
            width: '20%',
          },
        },
        {
          header: 'Location Info',
          title: 'Location Info',
          field: null,
          style: {
            width: '30%',
          },
          hideForTablet: isMobile(),
          hideForMobile: isMobile(),
        },
        {
          header: 'Process Info',
          title: 'Process Info',
          field: null,
          style: {
            idth: '10%',
          },
        },
        {
          header: 'Batch ID',
          title: 'Batch ID',
          field: null,
          style: {
            width: '10%',
          },
        },
        {
          header: 'Status Info',
          title: 'Status Info',
          field: null,
          hideForMobile: isMobile(),
        },
        {
          header: 'Actions',
          title: 'Actions',
          field: null,
          style: {
            width: '1%',
          },
        },
      ],
    },
    loading: {
      type: Boolean,
    },
    loadingError: {
      type: Boolean,
    },
    totalCount: {
      type: Number,
    },
  },
  data() {
    return {
      isMobile: isMobile(),
    };
  },
  methods: {
    updateSorter() {
      this.$emit('updateSorter');
    },
  },
};
</script>

<style lang="sass" scoped>
  .td-alert
    padding: 2rem
    text-align: center
  .table-wrapper
    overflow-x: auto
  .pager-container
    border-bottom: 1px solid #dee2e6
    border-width: 1px 0 0
    padding: 5.6px 12px
    background-color: #f9f9f9
</style>
